import CONF from 'config/conf.singleton';
import H from 'constants/httpMethod.const';
import endpoint from 'utils/backend/endpoint.util';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import actionBe from 'utils/mw/actionBe.util';

// NOTE: copied from checkVoucher in src/cashup/actions.js , make sure to remove that one

const beFindVoucher = actionBe('beFindVoucher', ({ L, AT, ATAG, number }) => {
  if (!fromAnyToTrimmed(number)) L.warn('()', 'Invalid number:', number);

  return endpoint(H.get, 'voucher/:salonId/search/?number=:number', {
    AT,
    ATAG,
    base: CONF.transactionApiRoot,
    params: { number },
  });
});

export default beFindVoucher;
